module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [(this.colors.length > 0) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("color.label"),
      "columns": 3,
      "error": _vm.getError('color', _vm.variation.sku),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": this.colors,
      "track-by": "code",
      "label": "label",
      "selectLabel": "Clique",
      "selectedLabel": "Selecionado",
      "placeholder": "Selecione a opção",
      "disabled": _vm.disabledInputs()
    },
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sizes.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("size.label"),
      "columns": 3,
      "error": _vm.getError('size', _vm.variation.sku),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.sizes,
      "track-by": "code",
      "label": "label",
      "selectLabel": "Clique",
      "selectedLabel": "Selecionado",
      "placeholder": "Selecione a opção",
      "disabled": _vm.disabledInputs()
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b2ce076","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/sicredi/provide/Variation.vue
// module id = 3136
// module chunks = 0